import {dietFrequencies} from './dietFrequency';
export const nutrients = [
 ['energyKcal100g','Energia','kcal'],['protein100g','Proteine','g'],
 ['carbohydrate100g','Carboidrati','g'],['fat100g','Grassi','g'],
 ['fiber100g','Fibre','g'],['salt100g','Sale','g']
];
const number = value => value!==null && value!==undefined && String(value).trim()!=='' && Number.isFinite(Number(value)) && Number(value)>=0 ? Number(value) : null;
const blank = () => Object.fromEntries(nutrients.map(([key])=>[key,null]));
function grams(row) {
 const quantity=number(row.quantity);if(quantity===null||quantity<=0)return null;
 const unit=(row.unit||'').trim().toLowerCase();
 const portion=number(row.gramsPerUnit);
 const practical=['ml','porzione','cucchiaio','cucchiaino','tazza','bicchiere','pezzo','fetta','vasetto','mestolo','piatto'].includes(unit);
 return unit==='g'?quantity:unit==='kg'?quantity*1000:practical&&row.foodCatalogItemId&&portion>0?quantity*portion:null;
}
export function rowNutrition(row,foods={},recipes={}) {
 if(row.foodRecipeId){
  const recipe=recipes[row.foodRecipeId],quantity=number(row.quantity);
  if(!recipe?.ingredients?.length)return {values:blank(),reason:'Ricetta senza ingredienti disponibili'};
  if(!['porzione','porzioni'].includes((row.unit||'').toLowerCase())||!quantity||!(recipe.servings>0))return {values:blank(),reason:'La ricetta richiede una quantità in porzioni e il numero di porzioni della preparazione'};
  const parts=recipe.ingredients.map(ingredient=>rowNutrition(ingredient,{...foods,[ingredient.foodCatalogItemId]:ingredient.foodCatalogItem||foods[ingredient.foodCatalogItemId]},{}));
  const values=Object.fromEntries(nutrients.map(([key])=>[key,parts.some(part=>part.values[key]===null)?null:parts.reduce((sum,part)=>sum+part.values[key],0)*quantity/recipe.servings]));
  return {values,reason:parts.some(part=>part.reason)?'Ingredienti della ricetta incompleti o con unità non convertibile':null};
 }
 const food=foods[row.foodCatalogItemId];
 if(!food)return {values:blank(),reason:'Alimento non collegato o non disponibile nel catalogo'};
 const weight=grams(row);
 if(weight===null)return {values:blank(),reason:'Indicare grammi: manca una conversione attendibile per questa quantità/unità'};
 const values=Object.fromEntries(nutrients.map(([key])=>[key,number(food[key])===null?null:Number(food[key])*weight/100]));
 return {values,reason:nutrients.some(([key])=>values[key]===null)?'Uno o più nutrienti non disponibili nel catalogo':null};
}
export function summarizeNutrition(rows,foods={},recipes={}) {
 const parts=rows.filter(row=>(row.food||row.name||'').trim()).map(row=>({row,...rowNutrition(row,foods,recipes)}));
 return {parts,count:parts.length,values:Object.fromEntries(nutrients.map(([key])=>{
  const known=parts.filter(part=>part.values[key]!==null);
  return [key,{value:known.length?known.reduce((sum,part)=>sum+part.values[key],0):null,missing:parts.length-known.length,complete:parts.length>0&&known.length===parts.length}];
 }))};
}

// A substitution replaces the food identity and portion; it must not inherit a recipe or quantity.
export function substituteDietRow(row, option) {
 return {...row,food:option.name||'',quantity:option.quantity??'',unit:option.unit||'',gramsPerUnit:option.gramsPerUnit??null,foodCatalogItemId:option.foodCatalogItemId||null,foodRecipeId:option.foodRecipeId||null,foodSource:option.foodSource||null};
}

export function matchingNutrientQuantity(row, option, nutrient, foods={}, recipes={}) {
 if(!nutrients.some(([key])=>key===nutrient))return {reason:'Nutriente non disponibile'};
 const source=rowNutrition(row,foods,recipes).values[nutrient];
 const unit=option.foodRecipeId?'porzione':'g';
 const perUnit=rowNutrition({...option,quantity:1,unit},foods,recipes).values[nutrient];
 if(!(source>0)||!(perUnit>0))return {reason:'Servono valori positivi del nutriente per entrambe le voci e una quantità di partenza calcolabile.'};
 const exact=source/perUnit;
 const quantity=Math.round(exact*10)/10;
 if(!Number.isFinite(quantity)||quantity<=0)return {reason:'Quantità non rappresentabile: verifica le voci del catalogo.'};
 return {quantity,unit,source,matched:quantity*perUnit};
}

export function weeklyAverageNutrition(rows, foods={}, recipes={}) {
 const frequency=dietFrequencies(rows);
 if(!frequency.valid)return null;
 const days=frequency.days.map(day=>({...day,summary:summarizeNutrition(rows.filter(row=>(Number(row.dayNumber)||1)===day.dayNumber),foods,recipes)}));
 return {values:Object.fromEntries(nutrients.map(([key])=>{
  const known=days.filter(day=>day.summary.values[key].value!==null);
  return [key,{value:known.length?known.reduce((sum,day)=>sum+day.summary.values[key].value*day.frequency,0)/7:null,missing:days.reduce((sum,day)=>sum+day.summary.values[key].missing,0),complete:days.every(day=>day.summary.values[key].complete)}];
 }))};
}
